import { CLASS_ASIDE_PANEL } from '../../constants';
import { getMessages } from '../../../../../../store/constants';

export const CLASS_ASIDE_PANEL_CLOSE = CLASS_ASIDE_PANEL + '__close';
export const LINK_CARD_BUTTON_TEXT = getMessages().getText('card_link.button');
